import { SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const player_option = (data: SSO_MODELS.PlayerOption) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    label: elements?.label?.value,
    value: elements?.value?.value,
    gender: elements?.gender?.value
  };
};

export default player_option;
